import React, { Component } from "react";
import { Link } from "react-router-dom";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      msg: null,
      type: null,
      flash: false,
      alert: null,
    };
  }

  render() {
    return (
      <nav
        className="navbar navbar-expand-lg navbar-light sticky-top bg-white shadow-sm trans-all"
        id="myNav"
      >
        <div className="container d-flex justify-content-between">
          <Link className="navbar-brand" to="/admin-wedding/index">
            <img
              src="/img/creatifa-logo-with-text.png"
              height="30"
              className="d-inline-block align-top"
              alt=""
            />
          </Link>

          <button
            onClick={this.handleLogout}
            className="btn d-none btn-outline-pink d-flex border-danger"
          >
            Logout
          </button>
        </div>
        {this.state.alert}
      </nav>
    );
  }
}

export default Header;
